// **********************************************************************
//
// Copyright (c) 2003-2017 ZeroC, Inc. All rights reserved.
//
// This copy of Ice is licensed to you under the terms described in the
// ICE_LICENSE file included in this distribution.
//
// **********************************************************************

var _ModuleRegistry = require("../Ice/ModuleRegistry").Ice._ModuleRegistry;

module.exports.IceGrid = 
    (
        require("../IceGrid/Admin"),
        require("../IceGrid/Descriptor"),
        require("../IceGrid/Exception"),
        require("../IceGrid/FileParser"),
        require("../IceGrid/Registry"),
        require("../IceGrid/Session"),
        require("../IceGrid/UserAccountMapper")
    ).IceGrid;



//////////////////
// WEBPACK FOOTER
// ./~/ice/src/IceGrid/IceGrid.js
// module id = 1038
// module chunks = 0